import axios from "axios";
import { API_URL } from "config/api/API_URL";

const history = async (data: {
    fromDate: string
    toDate: string
    search: string
    sort:string
    skip: number
    limit: number
    chainId:string
}) => (await axios.get(API_URL.HISTORY, {params:data,timeout: 100000})).data;

const vouchers = async () => (await axios.get(API_URL.VOUCHERS)).data;

const resendMail = async (data: {
    orderId: string,
    phoneNo?:string,
    email?:string,
}) => (await axios.post(API_URL.RESENDMAIL, data, { timeout: 100000})).data

const vouchersStatus = async (data: {
    listOrderId: string
}) => (await axios.get(API_URL.VOUCHERS_STATUS, {params:data})).data;

const reVerify = async (data: {
    transactionHash: string,
    chainId:string,
    orderId:string,
    phoneNo?:string,
    email?:string,
}) => (await axios.post(API_URL.REVERIFY, data, { timeout: 100000})).data

const giftCardVoucher = async () => (await axios.get(API_URL.GIFT_CARD_VOUCHER)).data;

export const historyApi = {
    history, vouchers, resendMail, vouchersStatus, reVerify, giftCardVoucher
}